import React, { useState, useEffect } from 'react';
import {
	Steps,
	Button,
	Input,
	DatePicker,
	Row,
	Col,
	Divider,
	Modal,
	Table,
	Space,
	Spin,
	message,
	Tag,
	Select
} from 'antd';
import { motion, AnimatePresence } from 'framer-motion';
import { SearchOutlined, ReloadOutlined, DownloadOutlined } from '@ant-design/icons';
import { formatMontant } from '../../utils/utils';
import { createProvision, getProvisions, downloadProvision, getMMarchandises } from '../../api/provision';
import { get_all_users } from '../../api/users';
import { getPermissionsFromToken, hasPermission } from "../../utils/utils";



const { Step } = Steps;
const { Option } = Select;
// Valeurs initiales du formulaire
const initialProvision = {
	ordonateur_id: localStorage.getItem("user_id"),
	date_facture: null,
	date_edition: null,
	ref_facture: "",
	ref_client: "",
	cleint_name: "",
	ref_dossier: "",
	origine: "",
	nb_colis: 0,
	nb_colis_0: "",
	poids_colis: 0,
	num_ot: "",
	num_dau: "",
	navire_ref: "",
	navire_du: "",
	destination: "",
	marchandise: "",
	ref_bl: "",
	nb_marchandise: 0,
	volume_cbm: 0,
	date_depart: null,
	date_arrive: null,
	quittance_num: "",
	emb: "",
	type_marchandise_id: null,
	type_conteneur: "",
	frais: {
		DET: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		DD: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		TVA: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		ARS_IRI: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		PGN: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		TVG: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		APMF: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		FACTURE_CESSION: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		SURESTARIES: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		CIVIO: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		DEBARQUEMENT: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		MAGASINAGES: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		DESINFECTIONS: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		REDEVANCE_COMMUNAL: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		DROITS_REGIONAL: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		LOCATION_LOGGERS: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		TRANSPORT: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		DEPLACEMENT: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		AUTRES_CHARGES_DOUANE: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		LIQUIDATION_DOUANE: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		AUTRES_CHARGE: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		CONTAINER_DEPOSIT_1: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		CONTAINER_DEPOSIT_2: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		CHARGE_TRANSIT: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
		COMMISSION_TRANSIT: { nombre: 0, prix_unitaire: 0, taxe: 0, tva: 0, montant_total: 0 },
	}
};

const ProvisionDashboard = () => {
	// Modal + formulaire
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [currentStep, setCurrentStep] = useState(0);
	const [currentProvision, setcurrentProvision] = useState(initialProvision);
	const [typeMarchandise, setTypeMarchandise] = useState([])
	// Liste des provisions
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [searchText, setSearchText] = useState("");
	const [listUsers, setlistUsers] = useState([])
	const fadeAnimation = {
		initial: { opacity: 0, y: 10 },
		animate: { opacity: 1, y: 0 },
		exit: { opacity: 0, y: -10 }
	};

	useEffect(() => {
		fetchMarchandise()
		fetchProvisions()
		fetchUsers()
	}, []);

	const fetchMarchandise = async () => {
		try {
			const res = await getMMarchandises();
			setTypeMarchandise(res.data || []);
		} catch (error) {
			message.error("Erreur lors de la récupération des marchandises");
		}
	}

	const handleChange = (field, value) => {
		setcurrentProvision(prev => ({ ...prev, [field]: value }));
	};

	const updateFrais = (key, field, value) => {
		setcurrentProvision(prev => {
			const updated = { ...prev.frais[key], [field]: Number(value) };
			updated.montant_total = updated.nombre * updated.prix_unitaire + updated.taxe + updated.tva;
			return { ...prev, frais: { ...prev.frais, [key]: updated } };
		});
	};

	// Étapes du formulaire
	const steps = [
		{
			title: 'Formulaire',
			content: (
				<AnimatePresence mode="wait">
					<motion.div
						key="form"
						initial={fadeAnimation.initial}
						animate={fadeAnimation.animate}
						exit={fadeAnimation.exit}
						transition={{ duration: 0.4 }}
					>
						{/* FACTURE */}
						<Divider orientation="left" style={{ fontWeight: 'bold', fontSize: 16, color: '#1890ff' }}>🧾 FACTURE</Divider>
						<Row gutter={16}>
							<Col span={12}><label>Date Facture</label><DatePicker style={{ width: '100%' }} onChange={(d, v) => handleChange("date_facture", v)} /></Col>
							<Col span={12}><label>Date Edition</label><DatePicker style={{ width: '100%' }} onChange={(d, v) => handleChange("date_edition", v)} /></Col>
							<Col span={12}><label>Réf Facture</label><Input value={currentProvision.ref_facture} onChange={e => handleChange("ref_facture", e.target.value)} /></Col>
							<Col span={12}><label>Réf Client</label><Input value={currentProvision.ref_client} onChange={e => handleChange("ref_client", e.target.value)} /></Col>
							<Col span={24}><label>Nom Client</label><Input value={currentProvision.cleint_name} onChange={e => handleChange("cleint_name", e.target.value)} /></Col>
						</Row>

						{/* DOSSIER */}
						<Divider orientation="left" style={{ fontWeight: 'bold', fontSize: 16, color: '#fa8c16' }}>📁 DOSSIER</Divider>
						<Row gutter={16}>
							<Col span={12}><label>Réf dossier</label><Input value={currentProvision.ref_dossier} onChange={e => handleChange("ref_dossier", e.target.value)} /></Col>
							<Col span={12}><label>Origine</label><Input value={currentProvision.origine} onChange={e => handleChange("origine", e.target.value)} /></Col>
							<Col span={12}><label>Destination</label><Input value={currentProvision.destination} onChange={e => handleChange("destination", e.target.value)} /></Col>
							<Col span={12}><label>Type Marchandise</label>
								<Select value={currentProvision.type_marchandise_id} onChange={e => handleChange("type_marchandise_id", e)} style={{ width: '100%' }}>
									{typeMarchandise.map((item) => (
										<Option key={item.id} value={item.id}>
											{item.nom}
										</Option>
									))}
								</Select>
							</Col>
							<Col span={12}><label>Réf BL</label><Input value={currentProvision.ref_bl} onChange={e => handleChange("ref_bl", e.target.value)} /></Col>
							<Col span={12}><label>Marchandise</label><Input value={currentProvision.marchandise} onChange={e => handleChange("marchandise", e.target.value)} /></Col>

						</Row>

						{/* TRANSPORT */}
						<Divider orientation="left" style={{ fontWeight: 'bold', fontSize: 16, color: '#52c41a' }}>🚛 TRANSPORT</Divider>
						<Row gutter={16}>
							<Col span={8}><label>Num OT</label><Input value={currentProvision.num_ot} onChange={e => handleChange("num_ot", e.target.value)} /></Col>
							<Col span={8}><label>Num DAU</label><Input value={currentProvision.num_dau} onChange={e => handleChange("num_dau", e.target.value)} /></Col>
							<Col span={8}><label>Navire Réf</label><Input value={currentProvision.navire_ref} onChange={e => handleChange("navire_ref", e.target.value)} /></Col>
							<Col span={12}><label>Date Départ</label><DatePicker style={{ width: '100%' }} onChange={(d, v) => handleChange("date_depart", v)} /></Col>
							<Col span={12}><label>Date Arrivée</label><DatePicker style={{ width: '100%' }} onChange={(d, v) => handleChange("date_arrive", v)} /></Col>
						</Row>

						{/* COLIS */}
						<Divider orientation="left" style={{ fontWeight: 'bold', fontSize: 16, color: '#722ed1' }}>📦 COLIS</Divider>
						<Row gutter={16}>
							<Col span={8}><label>Nombre colis</label><Input type="number" value={currentProvision.nb_colis} onChange={e => handleChange("nb_colis", e.target.value)} /></Col>
							<Col span={8}>
								<label>Nombre conteneur (FT)</label>
								<Row>
									<Col span={10}>
										<Input type="text" value={currentProvision.nb_colis_0} onChange={e => handleChange("nb_colis_0", e.target.value)} />
									</Col>
									<Col span={2} style={{ textAlign: 'center', paddingTop: 5 }}>
										<label>x</label>
									</Col>
									<Col span={12} style={{ display: 'flex', alignItems: 'center' }}>
										<Select value={currentProvision.type_conteneur} onChange={e => handleChange("type_conteneur", e)} style={{ width: '100%' }} placeholder="Conteneurs">
											<Option value="40FT">40FT</Option>
											<Option value="20FT">20FT</Option>
										</Select>
									</Col>
								</Row>

							</Col>
							<Col span={8}><label>Poids colis</label><Input type="number" value={currentProvision.poids_colis} onChange={e => handleChange("poids_colis", e.target.value)} /></Col>
							<Col span={8}><label>Volume CBM</label><Input type="number" value={currentProvision.volume_cbm} onChange={e => handleChange("volume_cbm", e.target.value)} /></Col>
							<Col span={8}><label>Quittance Numero</label><Input value={currentProvision.quittance_num} onChange={e => handleChange("quittance_num", e.target.value)} /></Col>
							<Col span={8}><label>EMB</label><Input value={currentProvision.emb} onChange={e => handleChange("emb", e.target.value)} /></Col>
						</Row>
					</motion.div>
				</AnimatePresence>
			)
		},
		{
			title: "Droits & Taxes",
			content: (
				<motion.div key="frais" initial={fadeAnimation.initial} animate={fadeAnimation.animate} exit={fadeAnimation.exit} transition={{ duration: 0.4 }}>
					<Divider orientation="left" style={{ fontWeight: "bold", fontSize: 16 }}>💰 DROITS & TAXES</Divider>
					<Row style={{ fontWeight: "bold", marginBottom: 10, textAlign: "center" }}>
						<Col span={6}>INTITULÉ</Col>
						<Col span={3}>NOMBRE</Col>
						<Col span={3}>PRIX UNI.</Col>
						<Col span={3}>TAXE</Col>
						<Col span={3}>TVA</Col>
						<Col span={6}>TOTAL</Col>
					</Row>

					{Object.keys(currentProvision?.frais ?? {}).map((key) => (
						<Row key={key} gutter={12} style={{ marginBottom: 12 }}>
							<Col span={6} style={{ fontWeight: "bold", paddingTop: 5 }}>{key.replace(/_/g, " ")}</Col>
							<Col span={3}><Input type="number" value={currentProvision.frais[key].nombre} onChange={e => updateFrais(key, "nombre", e.target.value)} /></Col>
							<Col span={3}><Input type="number" value={currentProvision.frais[key].prix_unitaire} onChange={e => updateFrais(key, "prix_unitaire", e.target.value)} /></Col>
							<Col span={3}><Input type="number" value={currentProvision.frais[key].taxe} onChange={e => updateFrais(key, "taxe", e.target.value)} /></Col>
							<Col span={3}><Input type="number" value={currentProvision.frais[key].tva} onChange={e => updateFrais(key, "tva", e.target.value)} /></Col>
							<Col span={6}><Input disabled value={formatMontant(currentProvision.frais[key].montant_total)} style={{ background: "#f5f5f5", fontWeight: "bold" }} /></Col>
						</Row>
					))}
				</motion.div>
			)
		}
	];

	// Création provision
	const handleCreateProvision = async () => {
		try {
			setLoading(true);
			await createProvision(currentProvision);
			message.success("Provision créée avec succès");
			setIsModalOpen(false);
			setcurrentProvision(initialProvision);
			setCurrentStep(0);
			fetchProvisions();
		} catch (error) {
			message.error("Erreur lors de la création de la provision");
		} finally {
			setLoading(false);
		}
	};

	// Récupération liste
	const fetchUsers = async () => {
		setLoading(true);
		try {
			const res = await get_all_users();
			setlistUsers(res.data || []);
		} catch (error) {
			message.error("Erreur lors de la récupération des users");
		} finally {
			setLoading(false);
		}
	};

	// Récupération liste
	const fetchProvisions = async () => {
		setLoading(true);
		try {
			const res = await getProvisions();
			setData(res.data || []);
		} catch (error) {
			message.error("Erreur lors de la récupération des provisions");
		} finally {
			setLoading(false);
		}
	};

	// useEffect(() => {
	// 	if (!typeMarchandise.length) return;

	// 	const type = typeMarchandise.find(t => t.id === currentProvision.type_marchandise_id);
	// 	console.log(type);
	// 	if (!type) return;

	// 	const prix_unitaire = Math.round(type.prix_ariary * type.value);

	// 	// Déterminer le nombre selon le type
	// 	let nombre = 0;
	// 	const id = type.id;
	// 	if (id === 1 || id === 4) {
	// 		nombre = Number(currentProvision.poids_colis) || 0;
	// 	} else if (id === 2 || id === 3) {
	// 		nombre = Number(currentProvision.nb_colis_0) || 0;
	// 	} else if (id === 5 || id === 6) {
	// 		nombre = Number(currentProvision.nb_colis) || 0;
	// 	}

	// 	const montant_total = Math.round(nombre * prix_unitaire
	// 		+ (currentProvision.frais.APMF.taxe || 0)
	// 		+ (currentProvision.frais.APMF.tva || 0));

	// 	setcurrentProvision(prev => ({
	// 		...prev,
	// 		frais: {
	// 			...prev.frais,
	// 			APMF: {
	// 				...prev.frais.APMF,
	// 				nombre,
	// 				prix_unitaire,
	// 				montant_total,
	// 			}
	// 		}
	// 	}));
	// }, [
	// 	currentProvision.type_marchandise_id,
	// 	currentProvision.poids_colis,
	// 	currentProvision.nb_colis,
	// 	currentProvision.nb_colis_0,
	// 	typeMarchandise,
	// 	currentProvision.frais.prix_unitaire,
	// ]);

	useEffect(() => {
		if (!typeMarchandise.length) return;

		const type = typeMarchandise.find(t => t.id === currentProvision.type_marchandise_id);
		if (!type) return;

		const prix_unitaire = Math.round(type.prix_ariary * type.value);

		let nombre = 0;
		const id = type.id;

		// 🔥 CAS TONNAGE
		if (id === 1 || id === 4) {
			nombre = (Number(currentProvision.poids_colis) || 0) / 1000; // conversion tonne
		}
		// 🔹 CAS NOMBRE COLIS
		else if (id === 2 || id === 3) {
			nombre = Number(currentProvision.nb_colis_0) || 0;
		}
		else if (id === 5 || id === 6) {
			nombre = Number(currentProvision.nb_colis) || 0;
		}

		const montant_total = Math.round(
			(nombre * prix_unitaire)
			+ (currentProvision.frais.APMF.taxe || 0)
			+ (currentProvision.frais.APMF.tva || 0)
		);

		setcurrentProvision(prev => ({
			...prev,
			frais: {
				...prev.frais,
				APMF: {
					...prev.frais.APMF,
					nombre,
					prix_unitaire,
					montant_total,
				}
			}
		}));
	}, [
		currentProvision.type_marchandise_id,
		currentProvision.poids_colis,
		currentProvision.nb_colis,
		currentProvision.nb_colis_0,
		typeMarchandise
	]);

	const handleDownload = async (record) => {
		try {
			setLoading(true);
			await downloadProvision(record);
			message.success(`Provision ${record.ref_facture} téléchargée`);
		} catch (error) {
			message.error("Erreur lors du téléchargement");
		} finally {
			setLoading(false);
		}
	};

	const filteredData = data.filter(
		item =>
			item.cleint_name?.toLowerCase().includes(searchText.toLowerCase()) ||
			item.ref_facture?.toLowerCase().includes(searchText.toLowerCase())
	);

	const columns = [
		{ title: "Id", dataIndex: "id", key: "id" },
		{
			title: "Date creation",
			dataIndex: "created_at",
			key: "created_at",
			render: (date) => new Date(date).toISOString().slice(0, 19).replace("T", " "),

		},
		{ title: "Réf Dossier", dataIndex: "ref_dossier", key: "ref_dossier" },
		{ title: "Réf Facture", dataIndex: "ref_facture", key: "ref_facture" },
		{ title: "Nom Client", dataIndex: "client_name", key: "client_name" },
		{
			title: "Date Facture",
			dataIndex: "date_facture",
			key: "date_facture",
			render: (date) => new Date(date).toISOString().slice(0, 19).replace("T", " "),
		},
		{
			title: "Facturier",
			dataIndex: "user_id",
			key: "user_id",
			filters: listUsers.map((u) => ({
				text: u.prenom,
				value: u.id,
			})),
			onFilter: (value, record) => record.user_id === value,
			render: (userId) => {
				const user = listUsers.find((u) => u.id === userId);
				return <Tag color="blue">{user ? user.prenom : "Inconnu"}</Tag>;
			},
		},
		{
			title: "Actions",
			key: "actions",
			render: (_, record) =>
				hasPermission(getPermissionsFromToken(), "TRANSIT_DOWNLOAD") && (
					<Button
						type="primary"
						icon={<DownloadOutlined />}
						onClick={() => handleDownload(record)}
					>
						Télécharger
					</Button>
				)


		}
	];


	return (
		<div style={{}}>
			{/* Modal création */}

			<Modal
				title="Créer une nouvelle provision"
				open={isModalOpen}
				width="60%"
				onCancel={() => setIsModalOpen(false)}
				footer={false}
				style={{ height: '95vh', overflowY: 'scroll', top: 0 }}
			>
				<Steps current={currentStep} size="small" style={{ marginBottom: 20 }}>
					{steps.map((s, i) => <Step key={i} title={s.title} />)}
				</Steps>

				<div>{steps[currentStep].content}</div>

				<div style={{ marginTop: 20, textAlign: "right" }}>
					{currentStep > 0 && <Button style={{ marginRight: 8 }} onClick={() => setCurrentStep(currentStep - 1)}>⬅️ Précédent</Button>}
					{currentStep < steps.length - 1 && <Button type="primary" onClick={() => setCurrentStep(currentStep + 1)}>Suivant ➡️</Button>}
					{currentStep === steps.length - 1 && <Button type="primary" onClick={handleCreateProvision}>💾 Générer</Button>}
				</div>
			</Modal>

			{/* Liste des provisions */}
			<Divider />
			<Space style={{ marginBottom: 16 }}>
				<Input
					placeholder="Recherche par nom client ou réf facture"
					value={searchText}
					onChange={(e) => setSearchText(e.target.value)}
					style={{ width: 300 }}
					prefix={<SearchOutlined />}
					allowClear
				/>
				<Button
					icon={<ReloadOutlined />}
					onClick={fetchProvisions}
					style={{
						background: '#10831cff', // bleu Ant Design
						color: '#fff',
						borderRadius: 6,
						padding: '0 16px',
						boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
						fontWeight: 'bold'
					}}
				>
					Actualiser
				</Button>
				{
					hasPermission(getPermissionsFromToken(), "TRANSIT_ADD") && <Button type="primary" onClick={() => setIsModalOpen(true)}>➕ Ajouter une provision</Button>
				}


			</Space>

			<Spin spinning={loading}>
				<div style={{
					height: '70vh',
					overflowY: "auto"
				}}>
					<Table
						columns={columns}
						dataSource={filteredData}
						rowKey={(record) => record.id}
						pagination={{
							pageSize: 10,
							position: ["bottomCenter"],
							className: "custom-pagination",
							style: {
								display: "flex",
								justifyContent: "center",
								marginTop: 12,
							},
							itemRender: (page, type, originalElement) => {
								if (type === "page") {
									return (
										<div
											style={{
												borderRadius: "50%",
												minWidth: 32,
												height: 32,
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												border: "1px solid #d9d9d9",
											}}
										>
											{page}
										</div>
									);
								}
								return originalElement;
							},
						}}
					/>
				</div>
			</Spin>
		</div>
	);
};

export default ProvisionDashboard;
